import { Armchair, ChefHat } from 'lucide-react';
import { HomeGame } from '@/types/game';
import { Button } from '@/components/ui/button';

interface GameRules {
  game: HomeGame;
}

export const GameRules = ({ game }: GameRules) => {
  return (
    <div id="rules-preparation" className="rounded-lg">
      <h2 className="mb-6 !text-2xl sm:!text-4xl font-bold sm:font-extrabold">
        Правила и подготовка
      </h2>
      <ul className="list-none gap-9 md:!text-xl lg:!text-2xl text-purple-100 flex flex-col 1920:flex-row">
        <li className="flex items-start gap-4">
          <Armchair className="w-8 h-8 fill-purple-500 text-purple-500 flex-shrink-0 mt-1" />
          <span>
            Правила расскажем в игре. А пока собирайте друзей, звоните коллегам или сажайте кота на
            диван — пусть знает, кто тут самый умный.
          </span>
        </li>
        <li className="flex items-start gap-4">
          <ChefHat className="w-8 h-8 text-purple-500 flex-shrink-0 mt-1" />
          <span>
            Запаситесь вкусняшками — мозгу на пользу, и для полного погружения можете распечатать{' '}
            {game.formsUrl ? (
              <Button
                asChild
                variant="link"
                className="p-0 h-auto inline underline text-primary"
                data-goal-id="download_game_forms_clicked"
              >
                <a className="inline" href={game.formsUrl} target="_blank" rel="noreferrer">
                  бланки
                </a>
              </Button>
            ) : (
              'бланки'
            )}
            . Всё, поехали!
          </span>
        </li>
      </ul>
    </div>
  );
};
